import React from 'react';

import {Icon} from '@spothero/ui';

const IconFaq = (props) => {
    return (
        <Icon data-testid="IconFaq" viewBox="0 0 24 24" {...props}>
            <path
                d="M12.0004 6C10.9575 6.00132 9.95759 6.41622 9.22011 7.1537C8.48263 7.89118 8.06773 8.89104 8.06641 9.934H10.0664C10.0664 8.867 10.9344 8 12.0004 8C13.0664 8 13.9344 8.867 13.9344 9.934C13.9344 10.532 13.4534 10.966 12.7184 11.56C12.4783 11.7481 12.2477 11.948 12.0274 12.159C11.0294 13.156 11.0004 14.215 11.0004 14.333V15H13.0004L12.9994 14.367C13.0004 14.351 13.0324 13.981 13.4404 13.574C13.5904 13.424 13.7794 13.274 13.9754 13.116C14.7544 12.485 15.9334 11.532 15.9334 9.934C15.9326 8.89106 15.518 7.89104 14.7806 7.15347C14.0433 6.41591 13.0434 6.00106 12.0004 6ZM11.0004 16H13.0004V18H11.0004V16Z"
                fill="black"
            />
            <path
                d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z"
                fill="black"
            />
        </Icon>
    );
};

export default IconFaq;
